<pbc-filter [config]="KundenFilterConfig" [filter]="kunden.filter$ | async" (filterChange)="kunden.filter$.next($event)"></pbc-filter>
